import BlogPost from "../../../../src/templates/blog-post";
import { graphql } from 'gatsby';
import CodeExample from "../../../../src/components/CodeExample";
import PatchHeader from "../../../../src/components/PatchHeader";
import * as React from 'react';
export default {
  BlogPost,
  graphql,
  CodeExample,
  PatchHeader,
  React
};